export const ARC_STAGES = [
	"confident",
	"resisting",
	"conceding",
	"seeking_fix",
] as const;
export type ArcStage = (typeof ARC_STAGES)[number];

export const PROETHICS_SCENARIO_IDS = [
	"scenario-1",
	"scenario-2",
	"scenario-3",
] as const;
export type ProethicsScenarioId = (typeof PROETHICS_SCENARIO_IDS)[number];

export type AvatarRole = "daria" | "dennis" | "smith";

export type TranscriptRole = "mentor" | AvatarRole;

export type TranscriptMessage = {
	id: string;
	role: TranscriptRole;
	text: string;
	audioBase64?: string;
};

// The app transcribes audio client-side, so it only ever sends text turns.
export type LearnerInput = { modality: "text"; text: string };

export type TurnRequest = {
	scenarioId: string;
	arcStage: ArcStage;
	transcript: { role: TranscriptRole; text: string }[];
	learnerInput: LearnerInput;
	// Absent on the first turn; the server creates the memory thread and
	// returns it via `data-thread-created`.
	threadId?: string;
};

export type SummativeCriterion = {
	name: string;
	description: string;
	reason: string;
	score: number;
};

export type SummativeResult = {
	criteria: SummativeCriterion[];
	feedback: string;
};

export type StreamPart =
	| { type: "data-learner-transcript"; data: { text: string } }
	| { type: "data-thread-created"; data: { threadId: string } }
	| { type: "data-avatar-reply"; data: { reply: string } }
	| { type: "data-avatar-audio-chunk"; data: { chunkBase64: string } }
	| { type: "data-avatar-audio-done"; data: Record<string, never> }
	| { type: "data-turn-state"; data: { arcStage: ArcStage } }
	| { type: "data-summative-stream"; data: Partial<SummativeResult> }
	| { type: "data-final-result"; data: SummativeResult };
